import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from 'components/consumer/consumer-breadcrumb/components/Breadcrumb';

const CustomerDashboardBreadcrumb = ({ items = [] }) => (
  <div className="mb-2 max-[1023px]:mt-0 max-[1023px]:mx-5 max-[1023px]:mb-2 max-[767px]:mt-0 max-[767px]:mx-3 max-[767px]:mb-2">
    <Breadcrumb
      items={[
        {
          label: 'Account',
          link: '/customer/dashboard/',
        },
        ...items,
      ]}
      color="light"
      noPadding
    />
  </div>
);

CustomerDashboardBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};

export default CustomerDashboardBreadcrumb;
